var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39052 4.76552C4.91122 4.24483 5.75544 4.24483 6.27614 4.76552L12 10.4894L17.7239 4.76552C18.2446 4.24483 19.0888 4.24483 19.6095 4.76552C20.1302 5.28622 20.1302 6.13044 19.6095 6.65114L13.8856 12.375L19.6095 18.0989C20.1302 18.6196 20.1302 19.4638 19.6095 19.9845C19.0888 20.5052 18.2446 20.5052 17.7239 19.9845L12 14.2606L6.27614 19.9845C5.75544 20.5052 4.91122 20.5052 4.39052 19.9845C3.86983 19.4638 3.86983 18.6196 4.39052 18.0989L10.1144 12.375L4.39052 6.65114C3.86983 6.13044 3.86983 5.28622 4.39052 4.76552Z",
    fill: "#EC094D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewClose);
export default __webpack_public_path__ + "static/media/new-close.698e9fcc8a212e7c673dbc9914b64d7a.svg";
export { ForwardRef as ReactComponent };